import { render, staticRenderFns } from "./stars_infos.vue?vue&type=template&id=c8f0defa&scoped=true&"
import script from "./stars_infos.vue?vue&type=script&lang=js&"
export * from "./stars_infos.vue?vue&type=script&lang=js&"
import style0 from "./stars_infos.vue?vue&type=style&index=0&id=c8f0defa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f0defa",
  null
  
)

export default component.exports